import { Box, Stack, Typography } from "@mui/material";
import { AppCard } from "../../../apps-integration/components/AppCard";
import { AppDetail } from "../../../apps-integration/components/app-detail/AppDetail";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import { BankTransferCard } from "../../../invoice/create/PaymentMethods/BankTransfer/components/BankTransferCard";
import { usePayoutMethods } from "../hooks/usePayoutMethods";

export const PayoutMethodsList = ({ showTitle = true, modalKeyPrefix = "Organization-PayoutMethod" }) => {
  const { paymentMethods, getAppForMethod } = usePayoutMethods();

  return (
    <Box
      sx={{
        background: "var(--fx-surface-sunken, #F8FAFC)",
        p: { xs: 2, md: 3 },
        width: "100%",
        minHeight: "100%",
        overflow: "auto",
      }}
    >
      {showTitle && (
        <Box sx={{ mb: 2.5 }}>
          <Typography sx={{ fontSize: 30, fontWeight: 900, color: "var(--fx-surface-text, #0F172A)", lineHeight: 1.2 }}>
            Payout Methods
          </Typography>
          <Typography sx={{ mt: 0.75, color: "var(--fx-surface-textsecondary, #64748B)", fontSize: 14 }}>
            Manage the payment and payout methods connected to this business.
          </Typography>
        </Box>
      )}

      <Box sx={{ maxWidth: 820, width: "100%" }}>
        <Typography sx={{ mb: 1.5, fontSize: 18, fontWeight: 800, color: "var(--fx-surface-text, #0F172A)" }}>
          Available payment methods
        </Typography>

        <Stack spacing={2} sx={{ width: "100%" }}>
          {paymentMethods.map((method) => (
            <Box key={method.id} sx={{ width: "100%" }}>
              <BaseModalComponent
                modalLabel={method.label || `${method.name} - App`}
                modalKey={`${modalKeyPrefix}-${method.id}`}
                elementTrigger={<AppCard app={method} onClick={() => {}} cardVariant="compact" sx={{ width: "100%", maxWidth: "100%" }} />}
              >
                {(() => {
                  const app = getAppForMethod(method.id);
                  return app ? (
                    <AppDetail
                      key={app.id}
                      app={app}
                      isInstalled={false}
                      onInstall={(appId) => console.log("Install:", appId)}
                      onUninstall={(appId) => console.log("Uninstall:", appId)}
                    />
                  ) : null;
                })()}
              </BaseModalComponent>
            </Box>
          ))}
          <Box sx={{ width: "100%" }}>
            <BankTransferCard />
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
